import type { JSX } from "react";

export function ErrorNotice({
  message,
  onRetry,
}: {
  readonly message: string;
  readonly onRetry: () => void;
}): JSX.Element {
  return (
    <div className="p-3 rounded-lg bg-red-500/10 border border-red-500/30 text-sm text-red-400 flex items-center justify-between gap-3">
      <span>{message}</span>
      <button
        type="button"
        onClick={onRetry}
        className="text-xs px-3 py-1 rounded border border-red-500/50 text-red-300 hover:text-red-200 hover:border-red-500 transition-colors"
      >
        Retry
      </button>
    </div>
  );
}
